import { FEATURES } from '@Constants/rx-ui/constants';
import RequestUrls from '@Constants/RequestUrlsConstants';
import { generateTraceHeaders } from '@Services/CorrelationId';
import * as AuthHelper from '@Services/Auth/AuthHelper';

export function isTexelAccessFenceEnabled() {
  return AuthHelper.isFeatureEnabled(FEATURES.texel_access_enabled);
}

export function isTexelAccessEnabled() {
  return isTexelAccessFenceEnabled() && !AuthHelper.isAnonymousUser();
}

export function appendReferrerToRedirectUrl(url) {
  const target = new URL(url, window.location.origin);
  const referrer = `${window.location.origin}${window.location.pathname}${window.location.search}`; // no hash
  target?.searchParams.set('referrer', referrer);
  return target?.toString();
}

export async function redirectToTexel() {
  const accessToken = AuthHelper.getAccessToken();
  // Using fetch here instead of MessageBroker.send to get the redirect URL,
  // because browser follows redirect seamlessly, so we're getting responsr not from /linkout but from destination redirect URL.
  const response = await fetch(RequestUrls.texelLinkout.url, {
    method: RequestUrls.texelLinkout.method,
    headers: {
      Authorization: `Bearer ${accessToken}`,
      ...generateTraceHeaders(),
    },
  });

  if (!response.redirected) {
    return Logger.reject('Texel redirect - linkout is not redirected', response);
  }

  return window.open(appendReferrerToRedirectUrl(response.url), '_blank');
}
